import { render, staticRenderFns } from "./mypagination.vue?vue&type=template&id=c2a5b93a&"
import script from "./mypagination.vue?vue&type=script&lang=js&"
export * from "./mypagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports